import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { dropdownColors } from '../../../app/colors';
import { textCss, truncateCss } from '../../../app/typography';
import { gray } from '@kizen/kds/Colors';

export default styled.li`
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  ${truncateCss};
  ${textCss()}
  padding-left: 12px;
  padding-right: 12px;
  ${({ selected }) =>
    selected &&
    css`
      color: ${gray['gray-600']};
    `}
  ${({ focused }) =>
    focused &&
    css`
      background-color: ${dropdownColors.hover};
    `}
  ${({ selected }) =>
    !selected &&
    css`
      &:hover {
        background-color: ${dropdownColors.hover};
      }
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: auto;
      color: ${gray['gray-600']};
      &:hover {
        background: none;
      }
    `}
`;
